export const params = {
  containerBlockRadius: "6px",
  boxShadow: "rgba(149, 157, 165, 0.2) 0 8px 24px",
};

export const colors = {
  background: "#F8F8F8",
  totalBlack: "#000000",
  coverBackground: "#666666",
  totalWhite: "#fff",
  grey95: "#191C22",
  grey90: "#2C2D37",
  grey80: "#363B4A",
  grey70: "#434856",
  grey60: "#727281",
  grey50: "#8E8E9F",
  grey40: "#BEBEC9",
  grey20: "#DFE0E5",
  grey05: "#F9F9F9",
  grey0: "#FBFBFB",
  lemon: "#FFE632",
  gold: "#FFD93A",
  beeline: "#FFC800",
  sienna: "#C29553",
  scarlet: "#FA3300",
  red10: "#F45151",
  magenta: "#E6008C",
  blue50: "#1790FF",
  darkBlue: "#7367F0",
  green: "#0BCE73",
  aquamarine: "#1EBEAA",
  violet: "#8C32C8",
  gradientYellow: "linear-gradient(90deg, #FAC800 1.82%, #FFDC0F 99.01%)",
  gradientAlfa: "linear-gradient(95.6deg, #FF4D41 0%, #FF4337 100%)",
  gradientYandex:
    "radial-gradient(106.26% 150.99% at -3.13% 19.4%, #48CCE0 5.21%, #505ADD 38.02%, #BE40C0 68.23%, #F39404 94.27%)",
};
